import { Flex, Paper, Title, Text } from "@mantine/core";
import { useUpdateCustomerData } from "../../../hooks/ui/";
import BookingConfirmationPaper from "../../bookingConfirmationPaper";
import NextStepsPaper from "../../nextStepsPaper";
import ContactUsPaper from "../../contactUsPaper";
import { REPLAY_BLOCK_CLASS } from "../../../utils/statsig";

export default function CustomerSummary() {
  const { customerData } = useUpdateCustomerData();

  return (
    <Flex justify="center" align="center">
      <Flex direction="column" maw={672} w={"100%"}>
        <Paper p={"xl"} radius={"24px"} mb={"xl"}>
          <Title order={2} mb="1rem" ff="var(--wallet-font-family-sambla-sans)">
            Tack <span className={REPLAY_BLOCK_CLASS}>{customerData.name}</span>
            !
          </Title>
          <Text mb={"lg"}>
            Nu har vi registrerat din fullmakt och ser över ditt
            pensionssparande. Vi har också skickat en bekräftelse till din mail.
          </Text>
          <BookingConfirmationPaper />
        </Paper>
        <NextStepsPaper />
        <ContactUsPaper />
      </Flex>
    </Flex>
  );
}
